import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import './panel.css';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import './nlp/tabler.css';

function fitText( o )
{
    o = $(o);
    if( !o.length ) return;
    var max = 3;
    while( o[0].offsetWidth < o[0].scrollWidth && max-- > 0 )
    {
        console.log( 'title', parseInt(o.css('fontSize')), o[0].offsetWidth, o[0].scrollWidth );
        o.css( {fontSize: parseInt(o.css('fontSize'))-2});
    }
}

var tab;


function DatasetBrowse(prop) {

    var global = window.GlobalVars;

     useEffect( function(a){
        $('#topbuttons').html('');
        if( window.hasPriv( 'admin', 'c_admin') )
        {
            var addBut = $('<Button id="addDataset" variant="primary" type="submit" class="mt-2 btn btn-primary"><i class="fa fa-plus mr-2"></i>Create New Dataset</Button>')
            addBut.on('click', () => {
                window.GlobalVars.currentDatasetId = null;
                window.GlobalVars.currentDataset = null;
                window.saveSession( function(){
                    window.goPage('datasetSetup');
                });
            })
            $('#topbuttons').append(addBut);

            var advBut = $('<Button id="addDataset" variant="primary" type="submit" class="ml-4 mt-2 btn btn-pink"><i class="fa fa-search mr-2" aria-hidden="true"></i>Global Search</Button>')
            advBut.on('click', () => {
                window.goPage('datasetAdvanced');
            })
            $('#topbuttons').append(advBut);
        }
        var match = {active:true};
        console.log( 'MATCH', {match:match})
        window.post( 'find_datasets', {match:match, getProjects: true}, function(res){
            console.log( 'DATASETS', res.data );
            var projects = res.data.records;
            var annotations = [];
            var results = $('#results').html('');
            console.log( 'PROJECTS', projects );
            if( !projects.length )
            {
                $('.alert').remove();
                var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No datasets found');
                $('#topbuttons').prepend(empty);
                return;
            }
            var allStates = {};
            projects.forEach( p => {
                if( p.states )
                {
                    for( var k in p.states )
                    {
                        allStates[k] = (allStates[k] ||0)+1;
                        p['state_'+k] = p.states[k];
                    }
                    // counts.push( {label:window.stateLabels[k], val:p.states[k]});
                }
                // addDataset( results, p );
            })
            console.log( 'allStates', allStates );

            function noCount(v) {
            }

            function listTags(v,lastV) {
                for( var k in v ) v[k].label = k;
                var ret = Object.values(v);
                ret.sort( (a,b) => a.count-b.count );
                return ret.map( i => i.label )
            }
            // return;
            var desc = {
                title: 'Datasets',
                columns: {
                    datasetName: 'Name',
                    // versionCount: 'Versions',
                    companyName: 'Company',
                    metaData2: 'Metadata',
                    tags: 'Tags',
                    numProjects: 'Projects',
                    items: 'Items',
                    s_datasetType: 'Type',
                },
                filter: true,
                search: true,
                sort: true,
                initialSort: 'modified',
                initialSortDir: -1,
                pageSize: 10,
                noFilter: {
                    modified:1,
                },
                noSort: null,
                centerCol: ['modified','active'],
				format: tabler.formatString,
				forceType: {
                    numProjects:1,
                    items:1,
                    modified: 1,
                },
                colWidth: {
                    name: 30,
                },
				formatCol:{
					modified: tabler.formatTimeAgoSec,
                    active: tabler.formatActive,
                    metaData2: frm.smallerText,
                    tags: frm.smallerText,
				},
                maxLinesCol: {
                    metadata: 4,
                    tags: 4,
                },
                selectMode: false,
                selectId: 'datasetId',
                // clickCol: ['stateLabel','source'],
            }
            desc.columns.modified = 'Updated';
            if( !window.hasPriv('admin')) delete desc.columns.companyName;
            // desc.columns.active = 'Active'
            console.log( 'DESC', desc )
            tab = tabler.table($('#documentlist'), desc, 'datasets' );
            tab.onSelect( function(o){
                console.log( 'select', o )
            })
            window.tab = tab;
            projects.forEach( a => {
                // console.log( 'adddataset', a )
                if( a.tags ) a.tags = listTags(a.tags)
                if( a.metadata ) {
                    var md = [];
                    for( var k in a.metadata ) md.push( k+':'+a.metadata[k])
                    a.metaData2 = md;
                    console.debug( 'mdx', md )
                }
                a.versionCount = a.datasetVersions.length;
                a.s_datasetType = window.DatasetTypes[a.datasetType]
                tab.addRow(a, function( col, row ){
                    console.log( 'tabler clickkkkk', col, row, row[col] )
                    var p = row;
                    window.GlobalVars.currentDatasetId = p.datasetId;
                    window.GlobalVars.currentDataset = p;
                    // tabler.clearCtx('datasets');
                    tabler.clearCtx('dataset_browse');
                    window.saveSession( function(){
                        // window.goPage('nlpBrowse');
                        window.goPage('datasetItems');
                    });
                })
            });
            tab.draw();
        });
    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div id="topbuttons"></div>

            <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
            </Table>
            <div id="results" className="project-browse">
            </div>
        </div>
    )
}

export default DatasetBrowse
